import controller from './tos.controller';
import template from './tos.html';
import './tos.scss';
/**
 * @ngdoc component
 * @name tos
 * @description
 * The tos component of the app.
 *
 * @memberof tos
 */
export default {
  /**
   * The controller class for the component.
   * @type {TosController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/tos/components/tos/tos.component.js